import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, required_if as requiredIf, email } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';

extend('required', {
    ...required,
    message: () => 'This field is required',
});

extend('requiredIf', {
    ...requiredIf,
    message: () => 'This field is required',
});

extend('email', {
    ...email,
    message: () => 'Not a valid email address',
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
